/**
 * Newsletter popup — shows after a configurable delay, respects dismissal via localStorage.
 */
class FabrixNewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.storageKey = 'fabrix-popup-dismissed';
  }

  connectedCallback() {
    const delay = parseInt(this.dataset.delay, 10) || 5;
    const cookieDays = parseInt(this.dataset.cookieDays, 10) || 7;

    // Check if already dismissed
    if (this.isDismissed(cookieDays)) return;

    // Don't show in theme editor preview mode unless explicitly testing
    if (Shopify && Shopify.designMode) return;

    // Show after delay
    this.timer = setTimeout(() => {
      this.show();
    }, delay * 1000);

    // Close handlers
    this.querySelectorAll('[data-close]').forEach((el) => {
      el.addEventListener('click', () => this.dismiss(cookieDays));
    });

    // Close on Escape key
    this.handleKeydown = (e) => {
      if (e.key === 'Escape') this.dismiss(cookieDays);
    };
    document.addEventListener('keydown', this.handleKeydown);
  }

  disconnectedCallback() {
    if (this.timer) clearTimeout(this.timer);
    if (this.handleKeydown) document.removeEventListener('keydown', this.handleKeydown);
  }

  isDismissed(cookieDays) {
    try {
      const dismissed = localStorage.getItem(this.storageKey);
      if (!dismissed) return false;
      const dismissedDate = new Date(dismissed);
      const now = new Date();
      const diffDays = (now - dismissedDate) / (1000 * 60 * 60 * 24);
      return diffDays < cookieDays;
    } catch {
      return false;
    }
  }

  show() {
    this.classList.add('fabrix-newsletter-popup--visible');
    this.setAttribute('aria-hidden', 'false');
    // Trap focus inside popup
    const firstInput = this.querySelector('input[type="email"]');
    if (firstInput) firstInput.focus();
  }

  dismiss(cookieDays) {
    this.classList.remove('fabrix-newsletter-popup--visible');
    this.setAttribute('aria-hidden', 'true');
    try {
      localStorage.setItem(this.storageKey, new Date().toISOString());
    } catch {
      // Storage unavailable
    }
  }
}

customElements.define('fabrix-newsletter-popup', FabrixNewsletterPopup);
